<ion-header>
    <div class="headerModalKeyboard">
        <span style="color: #fff; font-size: 2.5vw;">{{title | translate}}</span>
        <ion-icon (click)="dismissModal()" style="font-size: 3vw; color: #fff;" name="close"></ion-icon>

    </div>
</ion-header>

<div class="keyboardContainer">
    <div style="width: 100%;" class="simple-keyboard" ></div>
    <div class="inputContainer">
        <input #inputKeyboardValue class="inputKeyBoard" (keyup)="updateCursor(inputKeyboardValue.value)" (click)="updateCursor(inputKeyboardValue.value)" (select)="updateCursor(inputKeyboardValue.value)" autofocus />
        <div style="display: flex; width: 98%; justify-content: space-between;">
            <button (click)="clearKeyBoard()" class="clearInputButtonKeyBoard">{{'Limpiar' | translate}}</button>
            <button (click)="sendData()" class="enterInputButtonKeyBoard">{{'Aceptar' | translate}}</button>
        </div>
    </div>
</div>